var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order"},[_c('goods-info',{staticClass:"goodsinfo"}),_c('app-payment',{staticClass:"payment",on:{"paymentSelected":_vm.onPaymentSelected}}),_c('div',{staticClass:"pay-btn",on:{"click":_vm.doPay}},[_vm._v("立即支付"),_c('span',{staticClass:"pay-price"},[_vm._v(_vm._s(_vm.account))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }